<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <div class="row">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-file-search text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Historial
        </span>
      </div>
      <div v-if="!hideFilter" class="col col-sm col-12 text-right">
        <drop-down
          :items="filterOptions"
          :title="filterTitle(selectedFilter)"
          variant="rounded-dark"
        />
      </div>
    </div>
    <custom-result-not-found v-if="items.length === 0" />
    <time-line class="mt-4">
      <div v-for="(item, index) in items" :key="`item-index-${index}`">
        <time-line-item class="custom-time-line rounded">
          <template #icon>
            <em
              class="radius"
              :class="`fas fa-${item.eventTypeIcon}`"
              :style="{ color: item.eventTypeIconColor }"
            />
          </template>
          <template #date>
            <div class="date-container">
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ item.eventDate | date }}
              </div>
              <div class="color-black font-12 font-weight-normal hour">
                {{ item.eventDate | hour }}
              </div>
            </div>
          </template>
          <div v-if="!isFinding(item.eventTypeId)" id="main-info" class="row">
            <div
              class="col-12 col-sm-2 gradient-border text-md-center text-sm-left p-3 order-2 order-md-0 order-sm-2 ml-4 ml-md-0 ml-sm-4 mt-n3 mt-md-0 mt-sm-n3"
            >
              <div
                class="color-gray-6 font-14 ml-n5 d-sm-none d-md-block font-weight-normal"
              >
                Estatus:
              </div>
              <em
                class="fa fa-circle font-12 mr-2"
                :class="
                  `color-${getColor(
                    item.eventTypeId == eventTypesEnum.CambioDeEstatus
                      ? item.statusNewId
                      : item.statusId
                  )}`
                "
              />
              <span class="color-black font-16 font-weight-bold text-status">
                {{
                  item.eventTypeId == eventTypesEnum.CambioDeEstatus
                    ? item.statusNewName
                    : item.statusName
                }}
              </span>
            </div>
            <div class="col-9 p-3 pl-4 d-flex align-items-center pr-0">
              <div
                class="color-secondary-33 font-16 text-description font-weight-normal"
              >
                <div v-html="$options.filters.bold(item.eventDescription)" />
              </div>
            </div>
            <div
              class="col-1 my-2 border-left d-flex justify-content-center align-items-center toggle-action"
              @click="onToggle(index, item)"
            >
              <em
                class="font-18 cursor-pointer"
                :class="toggleClass(item.isOpen, item.eventTypeId)"
              />
            </div>
          </div>
          <div v-else class="row py-2">
            <div class="col-11 p-3 pl-4 d-flex align-items-center pr-0">
              <div
                class="color-secondary-33 font-16 text-description font-weight-normal ml-4"
              >
                <div v-html="$options.filters.bold(item.eventDescription)" />
              </div>
            </div>
            <div
              class="col-1 my-2 border-left d-flex justify-content-center align-items-center toggle-action"
              @click="onToggle(index, item)"
            >
              <em
                class="font-18 cursor-pointer"
                :class="toggleClass(item.isOpen, item.eventTypeId)"
              />
            </div>
          </div>
          <div
            v-if="item.isOpen"
            class="row bg-white mx-3 px-0 px-md-3 px-sm-0 py-0 py-md-4 py-sm-0 pb-3 rounded additional-panel"
          >
            <div v-if="showJournalNumber(item.eventTypeId)" class="col">
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Número de Jornal:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.journalNumber }}
              </div>
            </div>
            <div
              v-if="showCompliancePayroll(item.eventTypeId)"
              class="col mt-4 mt-md-0 mt-sm-4"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Cumplimiento de Pago:
              </div>
              <div class="badge badge-pill badge-primary p-2 bg-secondary-32">
                <span class="font-14 font-weight-bold mx-2 label-value">
                  {{
                    item.details.compliancePayment
                      ? item.details.compliancePayment + ' días '
                      : '-'
                  }}
                </span>
              </div>
            </div>
            <div
              v-if="showPayrollDate(item.eventTypeId)"
              class="col col-sm col-12 mt-4 mt-md-0 mt-sm-4"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Fecha de Nómina:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.payrollDate | date }}
              </div>
            </div>
            <div
              v-if="showReceiveDate(item.eventTypeId)"
              class="col col-sm col-12 mt-4 mt-md-0 mt-sm-4"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Fecha de Recibido:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.receiveDate | date }}
              </div>
            </div>
            <div
              v-if="showReceiveTypeName(item.eventTypeId)"
              class="col col-sm col-12 mt-4 mt-md-0 mt-sm-4"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Recibido:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.receiveTypeName || '-' }}
              </div>
            </div>
            <div
              v-if="showAssistanceCount(item.eventTypeId)"
              class="col col-sm col-12 mt-4 mt-md-0 mt-sm-4"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Asistencias:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.assistanceCount }}
              </div>
            </div>
            <div
              v-if="
                showDenialReason(
                  item.eventTypeId == eventTypesEnum.CambioDeEstatus
                    ? item.statusNewId
                    : item.statusId,
                  item.eventTypeId
                )
              "
              class="col mt-2 mt-md-0 mt-sm-12"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Razón:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.reasonName }}
              </div>
            </div>
            <div
              v-if="showManualAdjustmentReason(item.eventTypeId)"
              class="col mt-2 mt-md-0 mt-sm-12"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Razón:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.manualAdjustmentReason }}
              </div>
            </div>
            <div
              v-if="
                showDenialReason(
                  item.eventTypeId == eventTypesEnum.CambioDeEstatus
                    ? item.statusNewId
                    : item.statusId,
                  item.eventTypeId
                )
              "
              class="col col-sm col-12 mt-2 mt-md-0 mt-sm-12"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Comentario:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.reasonComment }}
              </div>
            </div>
            <div
              v-if="showComment(item.eventTypeId)"
              class="col mt-4 mt-md-0 mt-sm-4"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Comentario:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.addtionalPaymentComent }}
              </div>
            </div>
            <div
              v-if="showManualAdjustmentComment(item.eventTypeId)"
              class="col col-sm col-12 mt-2 mt-md-0 mt-sm-0"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Comentario:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.manualAdjustmentComment }}
              </div>
            </div>
            <div
              v-if="showUser(item.eventTypeId)"
              class="col mt-2 mt-md-0 mt-sm-4"
            >
              <div class="color-gray-6 font-14 font-weight-normal label-text">
                Usuario:
              </div>
              <div class="color-black font-16 font-weight-bold label-value">
                {{ item.details.user }}
              </div>
            </div>
            <div v-if="showFollowUp(item.eventTypeId)" class="col-12">
              <div class="row">
                <div class="col col-sm col-12 mt-4 mt-md-0 mt-sm-4">
                  <div
                    class="color-gray-6 font-14 font-weight-normal label-text"
                  >
                    Categoría:
                  </div>
                  <div class="color-black font-16 font-weight-bold label-value">
                    {{ item.details.followUpCategoryName }}
                  </div>
                </div>
                <div class="col col-sm col-12 mt-4 mt-md-0 mt-sm-4">
                  <div
                    class="color-gray-6 font-14 font-weight-normal label-text"
                  >
                    Usuario:
                  </div>
                  <div class="color-black font-16 font-weight-bold label-value">
                    {{ item.details.user }}
                  </div>
                </div>
              </div>
              <div class="row mt-2 mt-md-4 mt-sm-2">
                <div class="col mt-4 mt-md-0 mt-sm-4">
                  <div
                    class="color-gray-6 font-14 font-weight-normal label-text"
                  >
                    Comentario:
                  </div>
                  <div class="color-black font-16 font-weight-bold label-value">
                    {{ item.details.followUpComment }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br v-if="item.isOpen" />
        </time-line-item>
      </div>
    </time-line>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import DropDown from 'dropdown';
import CustomResultNotFound from 'custom-result-not-found';
import {
  getAssistanceEventType as _getAssistanceEventType,
  getAssistanceEventLog as _getAssistanceEventLog,
} from '@/modules/shared/scholarship.api.js';

import eventTypes from '@/utils/constants/assistanceEventTypes.js';
import assistanceApprovalStatus from '@/utils/constants/assistanceApprovalStatus.js';

export default {
  name: 'History',
  components: {
    TimeLine,
    TimeLineItem,
    DropDown,
    CustomResultNotFound,
  },
  filters: {
    bold(value) {
      if (!value) return '';
      return value.replace(/(\\b)/g, '<strong>');
    },
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    hideFilter: {
      type: Boolean,
      default: () => false,
    },
    defaultCategory: {
      type: Number,
      default: () => null,
    },
  },
  data: () => ({
    selectedFilter: null,
    filterOptions: [],
    items: [],
  }),
  computed: {
    toggleClass() {
      return (opened, eventTypeId) =>
        opened
          ? 'fas fa-angle-down color-green'
          : `fas fa-angle-right color-orange ${
              this.disabledToggle(eventTypeId) ? 'color-secondary-35' : ''
            }`;
    },
    getColor() {
      return (status) => {
        switch (status) {
          case assistanceApprovalStatus.Pendiente:
            return 'yellow';
          case assistanceApprovalStatus.Aprobado:
            return 'secondary-36';
          case assistanceApprovalStatus.Pagado:
            return 'green-light';
          case assistanceApprovalStatus.Denegado:
            return 'primary-14';
          default:
            return '';
        }
      };
    },
    filterTitle() {
      return (value) => this.filterOptions[value]?.label ?? 'Todos';
    },
    showJournalNumber() {
      return (eventType) => [].includes(eventType);
    },
    showPayrollDate() {
      return (eventType) =>
        [eventTypes.DocumentacionDeNomina].includes(eventType);
    },
    showReceiveDate() {
      return (eventType) =>
        [eventTypes.DocumentacionDeNomina].includes(eventType);
    },
    showReceiveTypeName() {
      return (eventType) =>
        [eventTypes.DocumentacionDeNomina].includes(eventType);
    },
    showAssistanceCount() {
      return (eventType) =>
        [eventTypes.DocumentacionDeNomina].includes(eventType);
    },
    showUser() {
      return (eventType) =>
        [
          eventTypes.DocumentacionDeNomina,
          eventTypes.Analizado,
          eventTypes.CambioDeEstatus,
          eventTypes.AjusteManual,
          eventTypes.PagoAdicional,
          eventTypes.RelacionDePagoPadre,
          eventTypes.RelacionDePagoHijo,
          eventTypes.JournalDePago,
          eventTypes.GeneracionArchivosDePago,
          eventTypes.ReinicioDocumentacionNomina,
          eventTypes.Hallazgo,
        ].includes(eventType);
    },
    showCompliancePayroll() {
      return (eventType) => [].includes(eventType);
    },
    showDenialReason() {
      return (assistanceApprovalStatusId, eventTypeId) =>
        assistanceApprovalStatusId == assistanceApprovalStatus.Denegado &&
        eventTypeId == eventTypes.CambioDeEstatus;
    },
    showManualAdjustmentReason() {
      return (eventType) => [eventTypes.AjusteManual].includes(eventType);
    },
    showComment() {
      return (eventType) => [eventTypes.PagoAdicional].includes(eventType);
    },
    showManualAdjustmentComment() {
      return (eventType) => [eventTypes.AjusteManual].includes(eventType);
    },
    showFollowUp() {
      return (eventType) => [eventTypes.Comentario].includes(eventType);
    },
    showPaymentRelation() {
      return (eventType) =>
        [
          eventTypes.RelacionDePagoPadre,
          eventTypes.RelacionDePagoHijo,
        ].includes(eventType);
    },
    eventTypesEnum() {
      return eventTypes;
    },
    disabledToggle() {
      return (eventType) =>
        [
          eventTypes.Disponible,
          eventTypes.FacturacionEnLineaSAEE,
          eventTypes.FacturacionEnLineaRP,
        ].includes(eventType);
    },
    isFinding() {
      return (eventType) => eventType == eventTypes.Hallazgo;
    },
  },
  async mounted() {
    if (!this.hideFilter) await this.callGetEventTypes();

    await this.callGetEventLogs(this.defaultCategory);
  },
  methods: {
    setActiveFilter(value) {
      this.selectedFilter = value;
    },
    setProp(rowIndex, prop, value) {
      this.items = this.items.map((item, index) => {
        if (index === rowIndex) {
          if (prop) {
            item[prop] = value;
          }
        }
        return item;
      });
    },
    onToggle(itemIndex, item) {
      if (item && !this.disabledToggle(item.eventTypeId)) {
        this.setProp(itemIndex, 'isOpen', !item.isOpen);
      }
    },
    async onChangeTypeHandler({ id }) {
      this.selectedFilter = id;
      this.callGetEventLogs(id);
    },
    async callGetEventTypes() {
      const { data } = await _getAssistanceEventType();
      if (data) {
        const filterOptionsMapped = data.map((x) => ({
          label: x.name,
          click: this.onChangeTypeHandler.bind(x.id, x),
        }));
        filterOptionsMapped.unshift({
          label: 'Todos',
          click: this.onChangeTypeHandler.bind(null, { id: null }),
        });
        this.filterOptions = filterOptionsMapped;
      }
    },
    async callGetEventLogs(eventTypeId) {
      const { data } = await _getAssistanceEventLog(this.id, eventTypeId);
      this.items = data;
    },
  },
};
</script>

<style scoped lang="scss">
.gradient-border {
  box-shadow: 8px 0 3px -3px #efefef !important;
}

::v-deep .custom-time-line {
  div:first-child {
    margin-right: 0px !important;
    padding-right: 10px !important;
  }
  .timeline__content--inner {
    padding: unset !important;
  }
  .icon-absolute {
    top: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  em.radius {
    background: #fff !important;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #fafafa;
  }
}

@media only screen and (max-width: 768px) {
  .date-container {
    padding-right: -10px !important;
    .fulldate {
      font-size: 11px !important;
    }
    .hour {
      font-size: 8px !important;
    }
  }

  .text-description {
    font-size: 12px !important;
    margin-left: 15px;
  }

  .text-status {
    font-size: 12px !important;
  }

  .additional-panel {
    .label-text {
      font-size: 10px !important;
    }
    .label-value {
      font-size: 12px !important;
    }
  }

  .timeline__container {
    width: 106% !important;
    margin-right: 1px !important;
  }

  ::v-deep .custom-time-line {
    div:first-child {
      margin-right: 0px !important;
      padding-right: 0px !important;
    }
    .w-date-fixed {
      width: auto !important;
      .date-container {
        padding-right: 1px !important;
      }
    }
    .icon-absolute {
      left: -13px !important;
      top: 26px;
      .radius {
        font-size: 10px;
        height: 22px !important;
        width: 22px !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
      }
    }
    .timeline__content--inner {
      margin-left: -6px !important;
    }
  }

  .toggle-action {
    border-left: unset !important;
  }
  .gradient-border {
    box-shadow: unset !important;
  }
}
</style>
